<div id="logo" class="mat-caption">
    <a [routerLink]="['/']">
        <img id="logo" src="/wp-content/themes/swarm/app/assets/images/logo.svg" />
    </a>
    <button class="toggle" mat-icon-button (click)="userSettings.toggle('menuColumnToggle')">
        <mat-icon>play_arrow</mat-icon>
    </button>
</div>
<nav role="navigation" id="main-menu" #nav>
    <ul #menu>
        <li *ngFor="let option of options" (mouseover)="setSubmenuPosition($event, option)">
            <a 
                [routerLink]="option.routerLink" 
                [queryParams]="option.queryParams" 
                [routerLinkActive]="'active'" 
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="setTitle(option.title)">
                <span class="material-icons">{{option.icon}}</span> <span class="button-text">{{option.title}}</span>
            </a>
            <div *ngIf="option.submenu" class="submenu">
                <ul>
                    <li *ngFor="let item of option.submenu">
                        <a
                            [routerLink]="item.routerLink" 
                            [queryParams]="item.queryParams" 
                            [routerLinkActive]="'active'" 
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="setTitle(option.title)">
                            <span class="button-text">{{item.title}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
        <li *ngFor="let view of vs.views | keyvalue: vs.views; let i = index">
            <a 
                [routerLink]="view.routerLink" 
                [queryParams]="view.queryParams" 
                [routerLinkActive]="'active'" 
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="setTitle(view.title)">
                <span class="material-icons" *ngIf="view.icon">{{view.icon}}</span> <span class="button-text">{{view.title}}</span>
            </a>
        </li>
    </ul>
</nav>
<div id="account" *ngIf="user">
    <div id="user">
        <span class="icon badge">
            <button (click)="toggleUserMenu()" class="user-menu-toggle"><mat-icon>emoji_nature</mat-icon></button>
            <span class="badge-warning" *ngIf="updateAvailable"></span>            
        </span>
        <ul class="menu mat-elevation-z2" [ngClass]="{open: userMenuOpen}">
            <li *ngIf="updateAvailable"><button (click)="update()">Update</button></li>
            <li *ngIf="permissionsService.userHasPermission(Permissions.EditGlobalBannedWords)">
                <a 
                    [routerLink]="['/settings', 'banned-words']"  
                    [routerLinkActive]="'active'" 
                    [routerLinkActiveOptions]="{ exact: true }">
                    Banned Words
                </a>
            </li>
            <li *ngIf="permissionsService.userHasPermission(Permissions.EditGlobalDisclosures)">
                <a 
                    [routerLink]="['/settings', 'disclosures']"  
                    [routerLinkActive]="'active'" 
                    [routerLinkActiveOptions]="{ exact: true }">
                    Disclosures
                </a>
            </li>
            <li *ngIf="permissionsService.userHasPermission(Permissions.EditGlobalTaxonomies)"
                [routerLink]="['/settings', 'taxonomies']" 
                [routerLinkActive]="'active'" 
                [routerLinkActiveOptions]="{ exact: true }">
                <a 
                    [routerLink]="['/settings', 'taxonomies']" 
                    [routerLinkActive]="'active'" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="setTitle('Taxonomies')">
                    Taxonomies
                </a>
            </li>
            <li *ngIf="permissionsService.userHasPermission(Permissions.EditGlobalTechniques)">
                <a 
                    [routerLink]="['/settings', 'techniques']" 
                    [routerLinkActive]="'active'" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="setTitle('Techniques')">
                    Techniques
                </a>
            </li>
            <li *ngIf="permissionsService.userHasPermission(Permissions.EditSiteVerticals)">
                <a 
                    [routerLink]="['/settings', 'verticals']" 
                    [routerLinkActive]="'active'" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="setTitle('Verticals')">
                    Verticals
                </a>
            </li>
            <li><button (click)="logout()">Logout</button></li>
        </ul>
        <div class="message mat-elevation-z2" *ngIf="updateAvailable && messageOpen">Please save your changes and update! <button class="button" (click)="update()">Update</button><span class="close" (click)="toggleMessage()"><mat-icon>close</mat-icon></span></div>
    </div>
</div>